/*
ABOUT >>
THIS FILE HAVE MULIPLE DYNAMIC INPUTS FOR MORE MAIN SECTION
FULLY DYNAMIC  

ACTIVE >>
ITS IN RUNNING POSITION 

UPDATES >>
IT WILL BE UPDATE TO MAKE MORE ENHANCE CODE 
*/


import React ,{useState , useEffect,useMemo, useRef} from 'react';
import AddNewDialog from './addNew-popup-list-v-2';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { TextBoxComponent ,NumericTextBoxComponent} from '@syncfusion/ej2-react-inputs';
import moment from 'moment';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
// import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';

import { AutoCompleteComponent } from '@syncfusion/ej2-react-dropdowns';
import DropdownService from './api.service-v-2';

import {
  CheckBoxComponent,
  ButtonComponent,
} from "@syncfusion/ej2-react-buttons";

const DynamicDropDownInput = (props) => {
  console.log(props)
  const [loading, setLoading] = useState(false);
  const [dataSourceState, setDataSourceState] = useState(props.dataSource.type == 'Data' ? props.dataSource?.data : []);
  const [dropdownID, setDropdownID] = useState(props.value.id ? props.value.id : undefined);
  const [dropdownValue, setDropdownValue] = useState(props.value.value ?props.value.value : '');
  const [addNew, setAddNew] = useState(props.addNew ? props.addNew : {});
  
  const [addNewClicked, setAddNewClicked] = useState(false);
  const [allowThisUseEffect, setAllowThisUseEffect] = useState(false);

  useEffect(() => {
    console.log(props)
    if(allowThisUseEffect == true){
    setTimeout(()=>{

      setDropdownValue(props.value.value)
      setDropdownID(props.value.id)
    },1000)
  }
  }, [props.value.value]);
  const refs = useRef({});

  // Assign a dynamic ref based on the name prop
  if (!refs.current[props.name.value]) {
    refs.current[props.name.value] = React.createRef();
  }
  const dynamicRef = refs.current[props.name.value];
  console.log(dynamicRef)
  const ddlFields: object = { value: 'value' };

  useEffect(() => {
    if(props.dataSource.type == 'Route' ){
      console.log(props.dataSource.type);
      console.log(props.dataSource.route);
      getDropdownService(props.dataSource.route)
      setTimeout(()=>setAllowThisUseEffect(true),300)
    }
    
    
  }, [props.dataSource?.route]);

  useEffect(() => {
    console.log(props.dataSource?.data)
    if(props.dataSource?.type == 'Data' ){
      setDataSourceState(props.dataSource.data);
      // dynamicRef.current.dataSour/ce = props.dataSource.data
      if(props.isAdd == true){
        if( props.value.id == 0 || props?.value?.id ){
        
        let filterData = props.dataSource.data.filter(res=> res.id == props.value.id)
        console.log(filterData)
        if(filterData.length > 0){
        setDropdownID(filterData[0].id)
        setDropdownValue(filterData[0].value)
        setTimeout(()=>setAllowThisUseEffect(true),300)
        }
      }
      }
    }
    
    
  }, [props.dataSource?.data]);

  const getDropdownService = async (type) => {
    try {
      setLoading(false)
      const response = await DropdownService.getAllForList(type);
      if (response.data || response.data.recordset) {
              setLoading(false)
              setDataSourceState(response.data.recordset);
              if(props.isAdd == true && props.value.id != 'undefined'  && props.value.id != null){
                let filterData = response.data.recordset.filter(res=>res.id == props.value.id)
                console.log(filterData)
                setDropdownID(filterData[0].id)
                setDropdownValue(filterData[0].value)
              }
       } else {
        setLoading(false)
        console.error("Invalid response structure:", response);
        setDataSourceState([])
      }
     } catch (error) {
      setLoading(false)
      
      setDataSourceState([])
    }
  };


  const handleInputFocus = (inputRef) => {if (inputRef ) {inputRef.current.showPopup();}};

  const handleChange = (e) =>{
    setDropdownID(e?.itemData?.id  || e?.itemData?.id == 0 ? e?.itemData?.id : undefined)
    setDropdownValue(e?.itemData?.value ? e?.itemData?.value : '')
    if(e?.itemData?.id  || e?.itemData?.id == 0  ){
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name.value]: {...prevValues[props.name.value] ,value :{id:e?.itemData?.id  || e?.itemData?.id == 0 ? e?.itemData?.id : undefined , value:e?.itemData?.value ? e?.itemData?.value :''} }
    }));
  }else{
      props.setInputProps((prevValues) => ({
        ...prevValues,
        [props.name.value]: {...prevValues[props.name.value] ,value :{id:e?.itemData?.id  || e?.itemData?.id == 0  ? e?.itemData?.id : undefined , value:e?.itemData?.value ? e?.itemData?.value :''} }
      }));

    }
  }

  const handleAddNewBlur = (id, ref, value, elementId, productArray, isHaveAddNew) => {
    if ( ref.current.value == null || ref.current.value === '' || id === undefined || id === null) {
      if (value !== '') {
        const isValueInProductDesc = productArray.some((e) => e.value === value);
        if (!isValueInProductDesc) {
          ref.current.element.focus();
          ref.current.element.select();
          console.log(ref.current.element)
          // const elem = document.getElementById(elementId).parentElement.parentElement.firstChild;
          const elem = ref.current.element.parentElement.parentElement.firstChild;
          elem.style.border = '3px solid red';
          setTimeout(() => {
            elem.style.border = '1px solid #c8c8c8';
          }, 1000);
        }
      }
      if (!isHaveAddNew) {
        ref.current.element.focus();
      }
    }
  };

  const onClosing = (e)=>{
console.log(e);
getDropdownService(props.dataSource.route)
const dynamicRef = refs.current[e];

console.log(dynamicRef.current)

dynamicRef.current.element.focus()

  }





  const itemTemplate = (data ,fields) => {
    // <td className="template-cell">{data.id}</td>
    // <td className="template-cell" style={{ textAlign: 'right' }}>{data.value}</td>
    console.log(fields)
    return (
      
          
            <tr className="template-row" key={data.id}>
              {
                fields.map((res ,key)=>{
                  return(
            <td className={`template-cell column-${res.field}-${key}`} style={{ textAlign: res.textAlign }}>
              { res.hasOwnProperty('type') ? 
              res.type ==  'date' ?  moment(data[res.field]).format(res.format) : res.type ==  'number' ?  data[res.field].toLocaleString(undefined, {
                minimumFractionDigits: res.format[1],
                maximumFractionDigits: res.format[1],
                useGrouping: true // adds the comma as a separator
            }) : data[res.field] 
            : data[res.field] 
            }
              </td>
              )
                })
              }
            </tr>          
        
    );
  };
  
  // Template for displaying the header
  // const headerTemplate = (data,fields) => (
  //   showHeader ?
  //   <table className="template-container">
  //     <thead>
  //       <tr className="template-row">
  //         <th className="template-cell" style={{ textAlign: 'center', color: '#5CC95E' }}>Producme</th>
  //         <th className="template-cell" style={{ textAlign: 'center', color: '#5CC95E' }}>Bal Qty</th>
  //       </tr>
  //     </thead>
  //   </table>
  //   : null
  // );

  return (
    loading ? (
      <div>... Loading {props.name.value ? props.name.value.replace(/([A-Z])/g, ' $1').trim() : ''}</div>
    ) : (
      <div>
        <AutoCompleteComponent 
          id={props.name.value} 
          
          dataSource={dataSourceState}  
          placeholder={props.caption ? props.caption : `Select ${props.name.replace(/([A-Z])/g, ' $1').trim()}`}
          fields={ddlFields}
          floatLabelType='Auto' 
          highlight={true}
          // ={(data)=>{
          //   return (<span><span className='name'>{data.id}</span><span className='name'>{data.value}</span></span>);
          // }}
        
          created={(e)=>(props.onCreated ? props.onCreated(e, props.name.value) : null)}
        
          focus={(e) =>(             
            props.onFocus ? props.onFocus(e, props.name.value) : null ,handleInputFocus(dynamicRef))}
        
          change={(e) => (props.onChange ? props.onChange({
            ...e?.itemData,
              id:e?.itemData?.id  || e?.itemData?.id == 0  ? e?.itemData?.id : undefined,
              value:e?.itemData?.value ? e?.itemData?.value : ''
          }, props.name.value) : null,handleChange(e))}
        
          select={(e) => (props.onSelect ? props.onSelect({
            ...e?.itemData,
            id:e?.itemData?.id  || e?.itemData?.id == 0  ? e?.itemData?.id : undefined,
            value:e?.itemData?.value ? e?.itemData?.value : '' 
        }, props.name.value): null,handleChange(e))}

        blur={() =>(
          props?.isControlBlur  == false? null :  handleAddNewBlur(dropdownID,dynamicRef,dropdownValue,props.name.value,dataSourceState,addNewClicked),
            props.onBlur ? props.onBlur({
              id:dropdownID,
              value:dropdownValue,
              dataSource:dataSourceState
            }, props.name.value) : null,console.log(dropdownID) )
          }
          value={dropdownValue}
          ref={dynamicRef}
          // disabled={props?.enabled   == undefined ? false : !props?.enabled}     
          // disabled={true}     
          enabled={props?.enabled   == undefined ? true : props?.enabled}
          itemTemplate={
            
            !props.isMultipleColumn ? null : (e) => {
            console.log(e);
            if(e.id){
              
              return <>
              <table className="template-container">
        {/* Render the table header only once */}
       
            { e.id == dataSourceState[0].id && props.multipleDropDown.showHeader == true && props.multipleDropDown.dataSource.length > 0? <thead>
          <tr className="template-row">
              {
                props.multipleDropDown.dataSource.map((res ,key)=>{
                  return(
                    <th className={`template-cell  column-${res.field}-${key}` }
                    style={{ textAlign: 'center', color: '#5CC95E',...(res.Size && { fontSize: res.Size }) ,
                  
                  }}>{res.headerText}</th>
                  )
                })
              }
            </tr>
        </thead>:null
            }
  
        {/* Loop over dataList to render rows */}
        
              <tbody>
              {itemTemplate(e , props.multipleDropDown.dataSource)}
              </tbody>
              </table>
              </>
            }else{
              return null

            }
          }
          }
          // headerTemplate={(e)=>{
            // return headerTemplate(e, props.multipleDropDown.dataSource)
            
          // }}


          // headerTemplate = {!props.isMultipleColumn 
          // ? null 
          // : (e) => {
          //     console.log(e);
          //     if (props.multipleDropDown.dataSource && props.multipleDropDown.dataSource.length > 0 && showHeader == true) {
          //         return headerTemplate(e, props.multipleDropDown.dataSource);
          //     }
          //     return null; // return nothing if the dataSource is empty
          // }}
                />
        <TextBoxComponent
          className='e-input'
          type='hidden'
          name={props.name.id}
          floatLabelType='Auto'
          value={dropdownID}
        />
        {addNew.Route && addNew.Security?
        <AddNewDialog 
        Route={addNew.Route} 
        Security={addNew.Security} 
        onClosed={onClosing} 
        RefName={props.name.value}
        />
        :null}
      </div>
    )
  );
};


const DynamicDateInput = (props) => {
  console.log(`${props.name } props: ${props}`)

  useEffect(()=>{
if(props.value == 'currentDate'){
  props.setInputProps((prevValues) => ({
    ...prevValues,
    [props.name]: {...prevValues[props.name] ,value :moment(new Date()).format('DD-MMM-YY')  }
  }));
}else if(props.isAdd == false){
  props.setInputProps((prevValues) => ({
    ...prevValues,
    [props.name]: {...prevValues[props.name] ,value :moment(props.value).format('DD-MMM-YY')  }
  }));

}
  },[])
  const handleBlur = (e) => {
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,value :e?.target?.value || prevValues[props.name].value}
    }));
  };
  const handleChange = (e) => {
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,value :e?.value || prevValues[props.name].value }
    }));
  };

  return (
    <>
      <DatePickerComponent
        id={props.name}
        name={props.name}
        placeholder={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
        floatLabelType='Auto'
        format='dd-MMM-yy'
        // {
        //   ...(props.min
        //     ? { ...props.min}
        //     : {})
        // }
        min={props?.min}
        max={props?.max}

        created={(e)=>(props.onCreated ? props.onCreated(e, props.name) : null)}
        onBlur={(e)=>(props.onBlur ? props.onBlur(e.target.value, props.name) : null ,handleBlur(e))}
        focus={(e) => props.onFocus ? props.onFocus(e, props.name) : null}
        onChange={(e) => (props.onChange ? props.onChange(e.value, props.name) : null,handleChange(e))}
        value={props.value == 'currentDate'?  new Date() : props.value || ''}
        disabled={props?.enabled   == undefined ? false : !props?.enabled}     
      />
    </>
  );
};

const DynamicNumericInputs = (props) => {
  console.log(props)
  // const formatNumberWithCommas = (number) => {
  //   return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // };
  const handleChange = (e) => {
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,value :e?.value == "" ? prevValues[props.name].value :  e.value}
    }));
  };
  const handleBlur = (e) => {
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,value :e?.target?.value == "" ?  parseFloat(0).toFixed(props.decimal || 0)  : parseFloat(e.target.value).toFixed(props.decimal || 0)}
    }));
  };
 
  const handleCreated = (e) => {
    console.log(e);
    // const value = parseFloat(props.value).toFixed(props.decimal || 0) || 0.0;
    const value = props.value || 0.0;
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {
        ...prevValues[props.name],
        value: value,
        // formattedValue: formatNumberWithCommas(value)
      }
    }));
  };
  return (
    <>
      <TextBoxComponent
        className='e-input'
        type='number'
        placeholder={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
        // placeholder={props.caption ? props.caption :''}
        name={props.name}
      
        id={props.name}
        floatLabelType='Auto'
        value={props.value || 0.0}
        // value={props.formattedV/alue || 0.0}
 
        created={(e)=>(handleCreated(e) , props.onCreated ? props.onCreated(e, props.name) : null )}
        onBlur={(e)=>(handleBlur(e) , props.onBlur ? props.onBlur(e.target.value, props.name) : null)}
        focus={(e) => props.onFocus ? props.onFocus(e, props.name) : null}
        onChange={(e) => (handleChange(e) , props.onChange ? props.onChange(e.value, props.name) : null)}
        enabled={props?.enabled == false  ?  props?.enabled :    true}     
        // disabled={!props?.enabled  false}

        />
    </>
  );
};


// const DynamicNumericInput = (props) => {
//   const [inputType, setInputType] = useState('text');

//   const handleChange = (e) => {
//     console.log(e);
//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name]: {
//         ...prevValues[props.name],
//         value: e?.value === "" ? prevValues[props.name].value : e.value
//       }
//     }));
//   };

//   const handleBlur = (e) => {
//     console.log(e);
//     setInputType('text'); // Change back to text on blur
//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name]: {
//         ...prevValues[props.name],
//         value: e?.target?.value === "" ? parseFloat(0).toFixed(props.decimal || 0) : parseFloat(e.target.value).toFixed(props.decimal || 0)
//       }
//     }));
//   };

//   const handleFocus = (e) => {
//     console.log(e);
//     setInputType('number'); // Change to number on focus
//     if (props.onFocus) {
//       props.onFocus(e, props.name);
//     }
//   };

//   const handleCreated = (e) => {
//     console.log(e);
//     const value = props.value || 0.0;
//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name]: {
//         ...prevValues[props.name],
//         value: value,
//       }
//     }));
//   };

//   return (
//     <>
//       <TextBoxComponent
//         className='e-input'
//         type={inputType}
//         placeholder={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
//         name={props.name}
//         id={props.name}
//         floatLabelType='Auto'
//         value={inputType == 'text' ?  props.value.toLocaleString() || 0.0 : props.value || 0.0}
//         created={(e) => (handleCreated(e), props.onCreated ? props.onCreated(e, props.name) : null)}
//         onBlur={(e) => (handleBlur(e), props.onBlur ? props.onBlur(e.target.value, props.name) : null)}
//         onFocus={handleFocus}
//         onChange={(e) => (handleChange(e), props.onChange ? props.onChange(e.value, props.name) : null)}
//         enabled={props?.enabled === false ? props?.enabled : true}
//       />
//     </>
//   );
// };


const DynamicNumericInput = (props) => {
  console.log(props)
  const [inputType, setInputType] = useState('text');
  const [displayValue, setDisplayValue] = useState(props.value || 0.0);

  useEffect(() => {
    if (inputType === 'text') {
      console.log(props.value)
      setDisplayValue(props.value.toLocaleString('en-US', { minimumFractionDigits: props.decimal || 0, maximumFractionDigits: props.decimal || 0 }));
    } else {
      setDisplayValue(props.value);
    }
  }, [props.value]);
  // }, [displayValue]);

  const formatNumberWithCommas = (number) => {
    let comma = number.toLocaleString('en-US', { minimumFractionDigits: props.decimal || 0, maximumFractionDigits: props.decimal || 0 });
    console.log(comma)
    return comma
  };

  const handleChange = (e) => {
    console.log(e);
    const value = e?.value === "" ? props.value : e.value;
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {
        ...prevValues[props.name],
        value: value
      }
    }));
    setDisplayValue(value);
  };

  const handleBlur = (e) => {
    console.log(e);
    const formattedValue = e?.event.target?.value === "" ? parseFloat(0).toFixed(props.decimal || 0) : parseFloat(e.event.target.value).toFixed(props.decimal || 0);
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {
        ...prevValues[props.name],
        value: formattedValue
      }
    }));
    console.log(formattedValue)
    setInputType('text'); // Change back to text on blur
    
    
    console.log(typeof formattedValue)
    console.log(formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ","))
    setDisplayValue(formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
  };

  const handleFocus = (e) => {
    console.log(e);
    setInputType('number'); // Change to number on focus
    setDisplayValue(props.value);
    if (props.onFocus) {
      props.onFocus(e, props.name);
    }
    
    setTimeout(()=>document.getElementById(`${props.name}_display`).select(),100)
    
  };

  const handleCreated = (e) => {
    console.log(e);
    const value = props.value || 0.0;
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {
        ...prevValues[props.name],
        value: value,
      }
    }));
    setDisplayValue(formatNumberWithCommas(value));
  };

  return (
    <>
      <TextBoxComponent
        className='e-input'
        type={inputType}
        placeholder={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
        name={`${props.name}_display`}
        id={`${props.name}_display`}
        floatLabelType='Auto'
        value={displayValue}
        style={{textAlign:'right',paddingRight:'8px'}}
        created={(e) => (handleCreated(e), props.onCreated ? props.onCreated(e, props.name) : null)}
        blur={(e) => (handleBlur(e), props.onBlur ? props.onBlur(e?.event.target.value, props.name) : null)}
        onFocus={handleFocus}
    
        onChange={(e) => (  handleChange(e), props.onChange ? props.onChange(e.value, props.name) : null)}
        enabled={props?.enabled === false ? props?.enabled : true}
      />
  <TextBoxComponent
        name={props.name}
        id={props.name}
        type='hidden'
        value={props.value}

  />
    </>
  );
};
 


// const DynamicNumericInput = (props) => {
//   const [inputType, setInputType] = useState('text');
//   const [displayValue, setDisplayValue] = useState('');
//   const [actualValue, setActualValue] = useState(props.value || 0.0);

//   useEffect(() => {
//     if (inputType === 'text') {
//       setDisplayValue(formatNumberWithCommas(actualValue));
//     } else {
//       setDisplayValue(actualValue);
//     }
//   }, [inputType, actualValue]);

//   const formatNumberWithCommas = (number) => {
//     return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//   };

//   const handleChange = (e) => {
//     const value = e?.value === "" ? 0 : e.value;
//     setActualValue(value);
//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name]: {
//         ...prevValues[props.name],
//         value: value
//       }
//     }));
//     setDisplayValue(value);
//   };

//   const handleBlur = (e) => {
//     setInputType('text');
//     setDisplayValue(''); // Hide value on blur
//     const value = e?.target?.value === "" ? 0 : parseFloat(e.target.value).toFixed(props.decimal || 0);
//     setActualValue(value);
//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name]: {
//         ...prevValues[props.name],
//         value: value
//       }
//     }));
//   };

//   const handleFocus = (e) => {
//     setInputType('number');
//     setDisplayValue(actualValue);
//     if (props.onFocus) {
//       props.onFocus(e, props.name);
//     }
//   };

//   const handleCreated = (e) => {
//     // let value = props.value < 1000 ? 0 : props.value;
//     console.log(props.value)
//     let value =  props.value || 0;
//     setActualValue(value);
//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name]: {
//         ...prevValues[props.name],
//         value: value,
//       }
//     }));
//     console.log(formatNumberWithCommas(value))
//     setDisplayValue(formatNumberWithCommas(value));
//   };

//   return (
//     <>
//       <TextBoxComponent
//         className='e-input'
//         type={inputType}
//         placeholder={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
//         name={props.name}
//         id={props.name}
//         floatLabelType='Auto'
//         value={displayValue}
//         created={(e) => (handleCreated(e), props.onCreated ? props.onCreated(e, props.name) : null)}
//         onBlur={(e) => (handleBlur(e), props.onBlur ? props.onBlur(e.target.value, props.name) : null)}
//         onFocus={handleFocus}
//         onChange={(e) => (handleChange(e), props.onChange ? props.onChange(e.value, props.name) : null)}
//         enabled={props?.enabled === false ? props?.enabled : true}
//       />
//     </>
//   );
// };
 

const DynamicTextInput = (props) => {
  console.log(props)
  const handleChange = (e) => {
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,value :e?.value == "" ? prevValues[props.name].value :  e.value}
    }));
  };
  const handleBlur = (e) => {
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,value :e?.target?.value == "" ?  "" : e.target.value}
    }));
  };
  const handleCreated = (e) => {
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,value :props.value || ""}
    }));
  };
  return (
    <>
      <TextBoxComponent
        className='e-input'
        placeholder={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
        name={props.name}
        id={props.name}
        floatLabelType='Auto'
        type={props.type ? props.type : 'text'}
        value={props.value || ''}
        created={(e)=>(handleCreated(e) , props.onCreated ? props.onCreated(e, props.name) : null )}
        onBlur={(e)=>(handleBlur(e) , props.onBlur ? props.onBlur(e.target.value, props.name) : null)}
        focus={(e) => props.onFocus ? props.onFocus(e, props.name) : null}
        onChange={(e) => (handleChange(e) , props.onChange ? props.onChange(e.value, props.name) : null)}
        enabled={props?.enabled == false  ?  props?.enabled :    true}     
        // disabled={!props?.enabled  false}
        
    multiline={props?.multiline || false} 
    
        />
    </>
  );
};



const DynamicCellInput = (props) => {
  const tooltipRef = useRef(null);
  
  const showTooltip = (target, message) => {
    if (tooltipRef.current) {
      tooltipRef.current.destroy(); // Destroy existing tooltip if any
    }
    tooltipRef.current = new TooltipComponent({
      content: `<span class="error-tooltip">${message}</span>`,
      position: 'TopCenter',
    });
    tooltipRef.current.appendTo(target);
    tooltipRef.current.open(target);
  };
  
  const hideTooltip = () => {
    if (tooltipRef.current) {
      tooltipRef.current.close(); // Close the tooltip
      tooltipRef.current.destroy(); // Destroy the tooltip instance
      tooltipRef.current = null; // Reset the ref
    }
  };
  const [errorMessage, setErrorMessage] = useState('');
  const refs = useRef({});

  // Assign a dynamic ref based on the name prop
  if (!refs.current[props.name]) {
    refs.current[props.name] = React.createRef();
  }
  const textBoxRef = refs.current[props.name];

  const handleChange = (e) => {
    const inputValue = e?.value || '';
    
    if (/^[0-9+]*$/.test(inputValue)) {
      setErrorMessage('');
      props.setInputProps((prevValues) => ({
        ...prevValues,
        [props.name]: { ...prevValues[props.name], value: inputValue }
      }));
      
      if (props.onChange) props.onChange(inputValue, props.name);
      
    } else {
      setErrorMessage('Only numbers and + sign are allowed');
      showTooltip(document.getElementById(props.name), `<span class="error-tooltip">Only numbers and + sign are allowed</span>`);
      setTimeout(() => {
        hideTooltip()
      }, 1000);
    }
  };

  const handleBlur = (e) => {
    if (errorMessage) {
      e.preventDefault(); // Prevents losing focus if there's an error
      showTooltip(document.getElementById(props.name), `<span class="error-tooltip">Only numbers and + sign are allowed</span>`);

      textBoxRef.current.element.focus();
      setTimeout(() => {
        hideTooltip()
      }, 1000);
      return;
    }else if(e?.target?.value == '' || e?.target?.value == "+"){
      showTooltip(document.getElementById(props.name), `<span class="error-tooltip">Only numbers and + sign are allowed</span>`);
      textBoxRef.current.element.focus();
      setTimeout(() => {
        hideTooltip()
      }, 1000);
      return;
    }
    else if(/^[0-9+]*$/.test(props.value)){
      hideTooltip()

    }
    else if(/^[0-9+]*$/.test(e?.target?.value)){
      hideTooltip()

    }else {
      // setErrorMessage('Only numbers and + sign are allowed');
      showTooltip(document.getElementById(props.name), `<span class="error-tooltip">Only numbers and + sign are allowed</span>`);
      textBoxRef.current.element.focus();
      setTimeout(() => {
        hideTooltip()
      }, 1000);
      return;
    }
    const inputValue = e?.target?.value || '';

    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: { ...prevValues[props.name], value: inputValue }
    }));

    if (props.onBlur) props.onBlur(inputValue, props.name);
  };

  const handleCreated = (e) => {
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: { ...prevValues[props.name], value: props.value || '' }
    }));

    if (props.onCreated) props.onCreated(e, props.name);
  };
  return (
    // <TooltipComponent
    //   content={errorMessage}
    //   position="TopCenter"
    //   openDelay={100}
    //   closeDelay={100}
    //   visible={!!errorMessage}
    // >
      <TextBoxComponent
        className='e-input'
        placeholder={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
        name={props.name}
        id={props.name}
        floatLabelType='Auto'
        ref={textBoxRef}
        type={props.type ? props.type : 'text'}
        value={props.value || ''}
        created={(e) => handleCreated(e)}
        onBlur={(e) => handleBlur(e)}
        onChange={(e) => handleChange(e)}
        enabled={props?.enabled !== false}
        multiline={props?.multiline || false}
      />
    // </TooltipComponent>
  );
};


// const DynamicCellInput = (props) => {
//   const [errorMessage, setErrorMessage] = useState('');
//   const textBoxRef = useRef(null);

//   const handleChange = (e) => {
//     const inputValue = e?.value || '';
    
//     if (/^[0-9+]*$/.test(inputValue)) {
//       setErrorMessage('');
//       props.setInputProps((prevValues) => ({
//         ...prevValues,
//         [props.name]: { ...prevValues[props.name], value: inputValue }
//       }));
      
//       if (props.onChange) props.onChange(inputValue, props.name);
//     } else {
//       setErrorMessage('Only numbers and + sign are allowed');
//     }
//   };

//   const handleBlur = (e) => {
//     if (errorMessage) {
//       e.preventDefault(); // Prevents losing focus if there's an error
//       textBoxRef.current.focus();
//       return;
//     }

//     const inputValue = e?.target?.value || '';

//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name]: { ...prevValues[props.name], value: inputValue }
//     }));

//     if (props.onBlur) props.onBlur(inputValue, props.name);
//   };

//   const handleCreated = (e) => {
//     props.setInputProps((prevValues) => ({
//       ...prevValues,
//       [props.name]: { ...prevValues[props.name], value: props.value || '' }
//     }));

//     if (props.onCreated) props.onCreated(e, props.name);
//   };

//   return (
//     <TooltipComponent
//   content={<span style={{ color: 'red' }}>{errorMessage}</span>}
//   target={`#${props.name}`}
//   position="TopCenter"
//   openDelay={100}
//   closeDelay={100}
//   visible={!!errorMessage}
// >
//   <TextBoxComponent
//     ref={textBoxRef}
//     className='e-input'
//     placeholder={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
//     name={props.name}
//     id={props.name}
//     floatLabelType='Auto'
//     type={props.type ? props.type : 'text'}
//     value={props.value || ''}
//     created={(e) => handleCreated(e)}
//     onBlur={(e) => handleBlur(e)}
//     onChange={(e) => handleChange(e)}
//     enabled={props?.enabled !== false}
//     multiline={props?.multiline || false}
//   />
// </TooltipComponent>

//   );
// };

// export default DynamicCellInput;

// export default ;


const DynamicEmailInput = (props) => {
  const tooltipRef = useRef(null);
  
  const showTooltip = (target, message) => {
    if (tooltipRef.current) {
      tooltipRef.current.destroy(); // Destroy existing tooltip if any
    }
    tooltipRef.current = new TooltipComponent({
      content: `<span class="error-tooltip">${message}</span>`,
      position: 'TopCenter',
    });
    tooltipRef.current.appendTo(target);
    tooltipRef.current.open(target);
  };
  
  useEffect(()=>{
return(
  hideTooltip()
)
  },[])
  const hideTooltip = () => {
    if (tooltipRef.current) {
      tooltipRef.current.close();
      tooltipRef.current.destroy();
      tooltipRef.current = null;
    }
  };

  const [errorMessage, setErrorMessage] = useState('');
  const refs = useRef({});

  if (!refs.current[props.name]) {
    refs.current[props.name] = React.createRef();
  }
  const textBoxRef = refs.current[props.name];

  const handleChange = (e) => {
    const inputValue = e?.value || '';
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (emailPattern.test(inputValue) || inputValue === '') {
      setErrorMessage('');
      props.setInputProps((prevValues) => ({
        ...prevValues,
        [props.name]: { ...prevValues[props.name], value: inputValue }
      }));

      if (props.onChange) props.onChange(inputValue, props.name);

    } else {
      setErrorMessage('Please Enter Valid Email Address');
      showTooltip(document.getElementById(props.name), `<span class="error-tooltip">Please Enter Valid Email Address</span>`);
      setTimeout(() => {
        hideTooltip()
      }, 1000);
    }
  };

  const handleBlur = (e) => {
    if (errorMessage) {
      e.preventDefault();
      showTooltip(document.getElementById(props.name), `<span class="error-tooltip">Please Enter Valid Email Address</span>`);
      textBoxRef.current.element.focus();
      setTimeout(() => {
        hideTooltip()
      }, 1000);
      return;
    } else if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(props.value)) {
      hideTooltip();
    
    } else if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test( e?.target?.value)) {
      hideTooltip();
    }else{
      showTooltip(document.getElementById(props.name), `<span class="error-tooltip">Please Enter Valid Email Address</span>`);
      textBoxRef.current.element.focus();
      setTimeout(() => {
        hideTooltip()
      }, 1000);
      return;
    }

    const inputValue = e?.target?.value || '';

    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: { ...prevValues[props.name], value: inputValue }
    }));

    if (props.onBlur) props.onBlur(inputValue, props.name);
  };

  const handleCreated = (e) => {
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: { ...prevValues[props.name], value: props.value || '' }
    }));

    if (props.onCreated) props.onCreated(e, props.name);
  };

  return (
    <TextBoxComponent
      className='e-input'
      placeholder={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
      name={props.name}
      id={props.name}
      floatLabelType='Auto'
      ref={textBoxRef}
      type='text'
      value={props.value || ''}
      created={(e) => handleCreated(e)}
      onBlur={(e) => handleBlur(e)}
      onChange={(e) => handleChange(e)}
      enabled={props?.enabled !== false}
      multiline={props?.multiline || false}
    />
  );
};



const DynamicCheckBoxInput = (props) => {
  console.log(props)
  const handleChange = (e) => {
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,value :e?.checked == true ? 1 : 0 }
    }));
  };
  // const handleBlur = (e) => {
  //   console.log(e)
  //   props.setInputProps((prevValues) => ({
  //     ...prevValues,
  //     [props.name]: {...prevValues[props.name] ,value :e.target.value == 'on' ? true : false}
  //   }));
  // };
  
  
  return (
    <>
    <CheckBoxComponent
        className="e-input"
        label={props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
        floatLabelType="Auto"
        checked={props.value ==  true ? 1 : false}
        change={(e)=>(handleChange(e) , props.onChange ? props.onChange(e.checked == true ? 1:0, props.name) : null)}
        onBlur={(e)=>( console.log(e), props.onBlur ? props.onBlur(props.value , props.name) : null)}
        disabled={props?.enabled   == undefined ? false : !props?.enabled}     

            />
            <TextBoxComponent
              name={props.name}
              id={props.name}
              value={props.value}
              type='hidden'

            />
      
    </>
  );
};

const DynamicHiddenInput = (props) => {
  console.log(props)
  
  const handleCreated = (e) => {
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,value :props.value}
    }));
  };
  return (
    <>
      <TextBoxComponent
        className='e-input'
        name={props.name}
        id={props.name}
        floatLabelType='Auto'
        value={props.value}
        created={(e)=>( handleCreated(),props.onCreated ? props.onCreated(e, props.name) : null )}
        type='hidden'
        
        />
    </>
  );
};

const DynamicButtonInput = (props) => {
  // Define the styles object
  const styles = {
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
  };

  // Log the props for debugging
  console.log(props);

  const handleClick = (e) =>{
    console.log(e)
    props.setInputProps((prevValues) => ({
      ...prevValues,
      [props.name]: {...prevValues[props.name] ,isClicked :true ,enabled:false }
    }));
  }
  // Return the component structure
  return (
    <div style={styles}>
      <ButtonComponent
        className="e-input"
        name={props.name}
        type='button'
        disabled={props.enabled == 'undefined' ? false : !props.enabled }
        id={props.name}
        onBlur={(e) => (e.preventDefault(),props.onBlur ? props.onBlur(props.name) : null)}
        onClick={(e) => (e.preventDefault(), handleClick(e) , props.onClick ? props.onClick(props.name) : null)}
      >
        {props.caption ? props.caption : props.name.replace(/([A-Z])/g, ' $1').trim()}
      </ButtonComponent>
    </div>
  );
};


const StructuredGenerate = ({ title , mainProps , Inputs }) => {
  console.log(Inputs)
  return (
    <div className='row'>
        <div  className={`col-sm-${12}  `} style={{textAlign:'center'}}>
            <h1 style={{padding:'4px'}}>{title}</h1>
            </div>
      {Inputs.map((res, index) => {
        console.log(res)
        let Input = res.Input;
      //   if(res.Input.name == "DynamicHiddenInput"){
      // // return(<Input {...res.Props} {...mainProps} />)
      // return(
      //   <div key={index} className={`col-sm-${res.ColumnSize  == undefined  ? 0 :   res.ColumnSize}`}>
      //       <Input {...res.Props} {...mainProps} />
      //     </div>
      // )
      //   }else{
      let generateColumnClasses = typeof res.Props.name === 'object' ?  `${res.Props.name.value}_Col_${res.ColumnSize  == undefined ? 4 :res.ColumnSize}` : `${res.Props.name}_Col_${res.ColumnSize  == undefined ? 4 :res.ColumnSize}` ;
     return  (
          <div key={index} className={`${generateColumnClasses} col-sm-${res.ColumnSize  == undefined ? 4 :res.ColumnSize}`}>
            <Input {...mainProps}  {...res.Props} />
          </div>

        )
      // }
      })}
    </div>
  );
};






const DynamicDialogInput = ({
  isVisible,
  onClose,
  header = "Alert",
  content, // Can be text or a React component
  showButtons = false,
  buttons = [],
}) => {
  return (
    <DialogComponent
      visible={isVisible}
      header={header}
      close={onClose ? onClose : null}
      showCloseIcon={true}
      // content={typeof content === 'string' ? content : null} // Only set content prop if it's a string
      content={content} // Only set content prop if it's a string
    >
      {/* Render content as a child if it's a component */}
      {typeof content !== 'string' && content}
      
      {/* Buttons */}
      {showButtons &&
        buttons.map((btn, index) => (
          <ButtonComponent
            key={index}
            onClick={btn.onClick}
            isPrimary={btn.isPrimary}


          >
            {btn.content}
          </ButtonComponent>
        ))}
    </DialogComponent>
  );
};



export {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicDateInput,
  DynamicNumericInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput,
  DynamicCellInput,
  DynamicDialogInput,
  DynamicEmailInput
};
